export default __webpack_public_path__ + "static/media/home-photography-img-10.0f41a26b.png";